export default function totalPage(total, limit = 10) {
  return Math.ceil(total / limit) || 1;
}
